var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIconW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.48 1.85449C10.4949 1.86943 10.5249 1.90866 10.5571 1.99414C10.5894 2.07969 10.6003 2.14702 10.6001 2.19922V2.37402L9.88232 5.21191L9.7251 5.83496H14.0005C14.2145 5.83504 14.4006 5.90901 14.5796 6.08789C14.7588 6.2671 14.8335 6.45369 14.8335 6.66797V8.00098C14.8335 8.04378 14.8286 8.09663 14.8169 8.16016C14.8069 8.21414 14.7926 8.26097 14.7749 8.30176L14.7729 8.30566L12.7739 13.002C12.7176 13.1239 12.6207 13.242 12.4565 13.3516C12.2971 13.4578 12.1477 13.5009 12.0005 13.501H5.8335V5.54199L10.0005 1.375L10.48 1.85449ZM3.50049 5.83496V13.501H1.8335V5.83496H3.50049Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconW);
export default __webpack_public_path__ + "static/media/Like_Icon_w.733941594c80b04103666db563954523.svg";
export { ForwardRef as ReactComponent };